import { useSyncExternalStore } from 'react';

// "tap" on a touch-first device, "click" with a mouse or trackpad. Keyed on the
// primary pointer rather than the viewport, so a tablet says "tap" too.

export interface PointerVerb {
  verb: 'tap' | 'click';
  Verb: 'Tap' | 'Click';
}

const QUERY = '(pointer: coarse)';
const TAP: PointerVerb = { verb: 'tap', Verb: 'Tap' };
const CLICK: PointerVerb = { verb: 'click', Verb: 'Click' };

/** The verb right now, for copy built outside React (a status string at dispatch). */
export function pointerVerb(): PointerVerb {
  if (typeof window === 'undefined') return CLICK;
  return window.matchMedia?.(QUERY)?.matches ? TAP : CLICK;
}

function subscribe(onChange: () => void) {
  const mq = window.matchMedia?.(QUERY);
  mq?.addEventListener?.('change', onChange);
  return () => mq?.removeEventListener?.('change', onChange);
}

/** The live verb for rendered copy. The server renders "click"; a phone
 *  switches to "tap" right after hydration. */
export function usePointerVerb(): PointerVerb {
  return useSyncExternalStore(subscribe, pointerVerb, () => CLICK);
}
